"use strict";

function readingTime(text, options) {
  var _a, _b, _c;

  var wordBound = ((_a = options) === null || _a === void 0 ? void 0 : _a.wordBound) || function (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t';
  };

  var wordsPerMinute = (_c = (_b = options) === null || _b === void 0 ? void 0 : _b.wordsPerMinute, _c !== null && _c !== void 0 ? _c : 200);
  var words = 0;

  for (var i = text.length - 1; i >= 0;) {
    while (i >= 0 && wordBound(text[i])) {
      i--;
    }

    if (i >= 0) {
      words++;

      while (i >= 0 && !wordBound(text[i])) {
        i--;
      }
    }
  }

  return {
    minutes: Math.ceil(words / wordsPerMinute),
    words: words
  };
}

module.exports = readingTime;